import React from "react"

const ASCENDING = 'ASC';
const DESCENDING = 'DESC';

const SortableTable = ({ headers, rows, defaultSort }) => {
  const initial = defaultSort || (headers.length > 0 ? { key: headers[0], direction: ASCENDING } : null);
  const [sortConfig, setSortConfig] = React.useState(initial);

  const hasActions = rows.some((row) => row._actions);
  const hasGender = headers.includes("Gender");

  const sortedRows = React.useMemo(() => {
    if (!sortConfig) return rows;
    let items = [...rows];
    items.sort((a, b) => {
      let a_val = a[sortConfig.key];
      let b_val = b[sortConfig.key];
      if (a_val == null) a_val = "";
      if (b_val == null) b_val = "";
      if (!isNaN(a_val) && a_val !== "") {
        a_val = parseFloat(a_val);
        b_val = parseFloat(b_val);
      }
      if (a_val < b_val) return sortConfig.direction === ASCENDING ? -1 : 1;
      if (a_val > b_val) return sortConfig.direction === ASCENDING ? 1 : -1;
      return 0;
    });
    return items;
  }, [rows, sortConfig]);

  const requestSort = (key) => {
    let direction = ASCENDING;
    if (sortConfig && sortConfig.key === key && sortConfig.direction === ASCENDING) {
      direction = DESCENDING;
    }
    setSortConfig({ key, direction });
  };

  const sortIndicator = (header) => {
    if (!sortConfig || sortConfig.key !== header) return null;
    return sortConfig.direction === ASCENDING ? " \u25B2" : " \u25BC";
  };

  if (sortedRows.length === 0) return null;

  return (
    <table className="table table-sm table-bordered table-striped draft-table">
      <thead className="white-text ccs-navy-bg">
        <tr>
          {headers.map((header) => (
            <th key={header} className="draft-col draft-header" onClick={() => requestSort(header)}>
              {header}{sortIndicator(header)}
            </th>
          ))}
          {hasActions && <th className="draft-col">Actions</th>}
        </tr>
      </thead>
      <tbody className="ccs-navy-txt">
        {sortedRows.map((row, index) => (
          <tr key={row._key || index}>
            {headers.map((header) => (
              <td key={header} className={`draft-col${hasGender ? (row["Gender"] === "Male" ? " male" : " female") : ""}`}>
                {row[header]}
              </td>
            ))}
            {hasActions && (
              <td dangerouslySetInnerHTML={{ __html: row._actions || "" }} />
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default SortableTable;
